import React, { useEffect } from 'react'
import styles from  './overview2.module.css'
import {Link, useNavigate} from 'react-router-dom'
const TOOLS=["HTML","CSS","JAVASCRIPT","REACT","NODE.JS","MONGODB","RESPONSIVE DESIGN","JWT"];

export default function Overview2() {
  const navigate=useNavigate();

  useEffect(()=>{
     window.scroll({top:0,behavior:"smooth"})
  },[])
  
  const navigateToProject=()=>{
    navigate('/project1')
  }
  
  const navigateToProject3=()=>{
    navigate('/project3')
  }
  return (
    <div className={styles.overview1}>
      <div className={styles.wrapper}>
      <div className={styles["logo-container"]}>
        <span className={styles["logo-wrapper"]}>
          <img src="/images/video.png"  alt="" className={styles.logo} />
          RyoTube
        </span>
      </div>
        <h3 className={styles.header}>Overview</h3>
        <p className={styles.overview}>
         RyoTube is a video platform inspired by Youtube. With the app, you can easily upload
         your own videos and share them with the world. you can also like or dislike videos, leave comments, 
         and even subscribe to your favorite channels to stay up-to-date on their latest uploads.
         User login by Google and Facebook account is available.
        </p>
        <div className={styles.tools}>
          {TOOLS.map((t,index)=>(
            <span className={styles.tool} key={index}>{t}</span>
          ))}
        </div>
        <div className={styles.devices}>
            <div className={styles["macbook-container"]}>
              <img src="./images/vp-macbook.png" alt="" className={styles.macbook} />
              <img src="./images/vp-mobile.png" alt="" className={styles.phone}/>
              <img src="./images/vp-ipad.png" alt="" className={styles.ipad}/>
            </div>
        </div>
        <h3 className={styles.header}>Design</h3>
        <div className={styles.gallery}>
            <img src="./images/vp-top.png" alt="" className={styles["vp-top"]} />
            <img src="./images/vp-contents.png" alt="" className={styles["vp-contents"]} />
            <img src="./images/vp-upload.png" alt="" className={styles["vp-upload"]} />
            <img src="./images/vp-login.png" alt="" className={styles["vp-upload"]} />
        </div>
        <div className={styles.icons}>
            <a href="https://www.linkedin.com/in/ryo-aoyama-21392222b/"><img src="./images/linkedin2.png" alt="" className={styles.linkedin}/></a>
            <a href='https://github.com/RyoGitacc/video-platform-RyoTube'><img src="./images/github-mark.png" alt="" className={styles.github}/></a>
        </div>
        <div className={styles['btn-container']}>
            <a href='https://video-platfrom-ryo-aoyama.netlify.app'>
            <button className={styles.btn}>Visit Website</button>
            </a>
        </div>
        <h3 className={styles.header}>More Works</h3>
        <div className={styles["more-work"]}>
           <div className={styles.classified} onClick={navigateToProject}></div>
           <div className={styles.notyet} onClick={navigateToProject3}></div>
        </div>
        <p className={styles.back}>
          <Link to='/' className={styles.link}>
            Back to home
          </Link>
        </p>
      </div>
    </div>
  )
}
